export interface Identifiable {
  getId(): string;
}

export function isIdentifiable(value: any): value is Identifiable {
  return "getId" in value;
}
